import { useEffect } from 'react'
import { useLoadSdkYuno } from '../../hooks'
import { UsePaymentRedirect } from './payment-redirect.types'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { useTranslation } from 'react-i18next'
import { dispatchLoaderEvent } from '../../utils/loader'
import { buildCallbackUrl, redirectAfterResultScreen, redirectTo } from '../../utils'

export const usePaymentRedirect: UsePaymentRedirect = () => {
  const checkoutInfo = queryClient.getQueryData([
    'checkout-info',
  ]) as CheckoutInfo
  const { isYunoLoaded } = useLoadSdkYuno()
  const { i18n } = useTranslation()

  const initSdk = async () => {
    const yuno = await Yuno.initialize(checkoutInfo.merchant_public_api_key)
    const showResultScreen = checkoutInfo.payment_link?.show_result_screen ?? false
    const hasReturnUrl = !!checkoutInfo.checkout_return_url

    await yuno.startCheckout({
      checkoutSession: checkoutInfo.checkout_session,
      elementSelector: '#root-payment-redirect',
      countryCode: checkoutInfo.country,
      language: i18n.resolvedLanguage as any,
      showPaymentStatus: showResultScreen || !hasReturnUrl,
      showLoading: false,
      yunoCreatePayment() {
        throw new Error('Not implemented')
      },
      yunoPaymentResult: (status: string) => {
        if (checkoutInfo.checkout_return_url) {
          if (showResultScreen) {
            const url = buildCallbackUrl(checkoutInfo.checkout_return_url, status, null)
            redirectAfterResultScreen(url)
          } else {
            dispatchLoaderEvent({ showLoader: true })
            redirectTo(checkoutInfo.checkout_return_url)
          }
        }
      },
    })

    yuno.continuePayment().then(() => {
      dispatchLoaderEvent({ showLoader: false })
    })
  }

  useEffect(() => {
    if (isYunoLoaded) {
      initSdk()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYunoLoaded])
}
